<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title bg-primary">
        <h1 class="text-bold text-white">Scan Order Number (START)</h1>
      </div>
      <div class="grid-body">
        <div class="row">
          <form @submit.prevent="repair()">
            <div class="col-md-12">
              <input
                type="text"
                v-model="formData.shirtOrderId"
                :placeholder="message"
                class="form-control scan-shirt"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>

    <!-- Modal -->
    <div
      class="modal"
      id="box-modal"
      tabindex="-1"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold">Input Box Data</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="row">
              <div class="col-md-12 text-center">
                <button
                  :class="
                    'btn xs btn-default x-3 btn-color text-capitalize ' +
                    textColor(color.title_en)
                  "
                  @click="setColor($event, color.title_en)"
                  :key="index"
                  v-for="(color, index) in dropDownData.boxColors"
                >
                  {{ color.title_en }} /
                  {{ color.title_th }}
                </button>
              </div>
              <div class="col-md-12">
                <div class="form-group box-number">
                  <label for="">Box Number</label>
                  <input
                    type="text"
                    placeholder="123"
                    @keyup.enter="next()"
                    class="form-control"
                    v-model="formData.boxNumber"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="next()">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="reason-modal"
      tabindex="-1"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold">Input Box Data</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="row">
              <div class="col-md-12">
                <form @submit.prevent="submit()">
                  <p-radio
                    class="p-default p-curve"
                    v-model="formData.reasonId"
                    :value="index"
                    color="danger"
                    :key="index"
                    v-for="(reason, index) in dropDownData.reasons"
                  >
                    <span>
                      # <span v-if="index != 0">{{ pad(index, 3) }} - </span>
                      {{ reason.title_th }}
                    </span>
                  </p-radio>
                  <input type="submit" class="d-none" />
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              Cancel
            </button>
            <button type="button" class="btn btn-primary" @click="submit()">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      formData: {
        reasonId: 0,
      },
      message: "Order Number",
      dropDownData: {},
    };
  },
  mounted() {
    this.getDropDownData();
    $(".scan-shirt").focus();
  },
  methods: {
    async getDropDownData() {
      let res = await axios.get("shirt_orders/repair/dropdown");
      this.dropDownData = res.data;
    },
    repair() {
      show_modal("#box-modal");
    },
    next() {
      if (!this.formData.boxColor) {
        toastr.error("Please Select Color");
      } else if (!this.formData.boxNumber) {
        toastr.error("Please Input Box Number");
      } else {
        hide_modal("#box-modal");
        show_modal("#reason-modal");
      }
    },
    async submit() {
      try {
        hide_modal("#reason-modal");
        $(".loading").show();
        let res = await axios.post("shirt_orders/repair/", this.formData);
        if (res) {
          $(".btn-color").css("background", "#d1dade");
          $(".btn-color").css("color", "black");
          this.message = this.formData.shirtOrderId;
          this.formData.shirtOrderId = null;
          this.formData.boxColor = null;
          this.formData.boxNumber = null;
          this.formData.reasonId = 0;
          $(".loading").hide();
          toastr.success("Success");
        }
      } catch (error) {
        $(".loading").hide();
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          let message = error.response.data.message;
          Swal.fire(message, "", "error");
        }
      }
    },
    textColor(color) {
      return color === "yellow" || color === "pink" ? "text-black" : "";
    },
    setColor(event, color) {
      $(".btn-color").css("background", "#d1dade");
      $(".btn-color").css("color", "black");
      $(event.target).css("background", color);
      $(event.target).css("color", "white");
      this.formData.boxColor = color;
    },
    pad(number, width, padWith = "0") {
      number = number + "";
      return number.length >= width
        ? number
        : new Array(width - number.length + 1).join(padWith) + number;
    },
  },
};
</script>

<style scoped>
.scan-shirt {
  font-size: 90px !important;
  height: 200px;
}
.btn-lg {
  height: 50px;
  font-size: 25px;
}
.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
}
.message {
  font-size: 90px;
}
.x-3 {
  margin-right: 3px;
  margin-bottom: 3px;
  color: black;
}
.box-number {
  margin-top: 50px;
}
.box-number input {
  height: 53px;
  font-size: 20px;
}
.text-capitalize {
  text-transform: capitalize;
}

.pretty {
  margin-bottom: 13px;
  display: block !important;
}
.d-none {
  display: none;
}
</style>
